/* DOCTOR */
export const GET_DOCTOR_LISTING = "GET_DOCTOR_LISTING";
export const GET_DOCTOR_LISTING_SUCCESS = "GET_DOCTOR_LISTING_SUCCESS";
export const GET_DOCTOR_LISTING_FAIL = "GET_DOCTOR_LISTING_FAIL";

export const RESET_DOCTOR_STATE = 'RESET_DOCTOR_STATE';
export const RESET_DOCTOR_ACTION_STATE = 'RESET_DOCTOR_ACTION_STATE';

export const GET_DOCTOR_DETAILS = "GET_DOCTOR_DETAILS";
export const GET_DOCTOR_DETAILS_SUCCESS = "GET_DOCTOR_DETAILS_SUCCESS";
export const GET_DOCTOR_DETAILS_FAIL = "GET_DOCTOR_DETAILS_FAIL";

export const ADD_DOCTOR = "ADD_DOCTOR";
export const ADD_DOCTOR_SUCCESS = "ADD_DOCTOR_SUCCESS";
export const ADD_DOCTOR_FAIL = "ADD_DOCTOR_FAIL";

export const UPDATE_DOCTOR = "UPDATE_DOCTOR";
export const UPDATE_DOCTOR_SUCCESS = "UPDATE_DOCTOR_SUCCESS";
export const UPDATE_DOCTOR_FAIL = "UPDATE_DOCTOR_FAIL";

export const DELETE_DOCTOR = "DELETE_DOCTOR";
export const DELETE_DOCTOR_SUCCESS = "DELETE_DOCTOR_SUCCESS";
export const DELETE_DOCTOR_FAIL = "DELETE_DOCTOR_FAIL";

export const DOCTOR_ACTIVATION = "DOCTOR_ACTIVATION";
export const DOCTOR_ACTIVATION_SUCCESS = "DOCTOR_ACTIVATION_SUCCESS";
export const DOCTOR_ACTIVATION_FAIL = "DOCTOR_ACTIVATION_FAIL";

export const GET_DOCTOR_HISTORY_LISTING = "GET_DOCTOR_HISTORY_LISTING";
export const GET_DOCTOR_HISTORY_LISTING_SUCCESS = "GET_DOCTOR_HISTORY_LISTING_SUCCESS";
export const GET_DOCTOR_HISTORY_LISTING_FAIL = "GET_DOCTOR_HISTORY_LISTING_FAIL";

export const EXPORT_DOCTOR_LISTING = "EXPORT_DOCTOR_LISTING";
export const EXPORT_DOCTOR_LISTING_SUCCESS = "EXPORT_DOCTOR_LISTING_SUCCESS";
export const EXPORT_DOCTOR_LISTING_FAIL = "EXPORT_DOCTOR_LISTING_FAIL";

export const GET_DOCTOR_ORDERS = "GET_DOCTOR_ORDERS";
export const GET_DOCTOR_ORDERS_SUCCESS = "GET_DOCTOR_ORDERS_SUCCESS";
export const GET_DOCTOR_ORDERS_FAIL = "GET_DOCTOR_ORDERS_FAIL";

export const GET_DOCTOR_COMMISSION = "GET_DOCTOR_COMMISSION";
export const GET_DOCTOR_COMMISSION_SUCCESS = "GET_DOCTOR_COMMISSION_SUCCESS";
export const GET_DOCTOR_COMMISSION_FAIL = "GET_DOCTOR_COMMISSION_FAIL";

export const GET_DOCTOR_COMMISSION_BREAKDOWN = "GET_DOCTOR_COMMISSION_BREAKDOWN";
export const GET_DOCTOR_COMMISSION_BREAKDOWN_SUCCESS = "GET_DOCTOR_COMMISSION_BREAKDOWN_SUCCESS";
export const GET_DOCTOR_COMMISSION_BREAKDOWN_FAIL = "GET_DOCTOR_COMMISSION_BREAKDOWN_FAIL";